import React from 'react';
import {useSelector} from "react-redux";

const useAccountType = () => {
    const [accountType, setAccountType] = React.useState('');
    const types = useSelector(state => state.user?.user_types)?.map(type => type.slice(1));

    React.useEffect(() => {
        if (types?.includes('oper')) {
            setAccountType('oper')
        } else if (types?.includes('pete')) {
            setAccountType('pete')
        }
    }, [types]);

    return [accountType];
}


export default useAccountType;